import { type Actions, ActionType } from './buildings.actions';
import { buildingAdapter, initialState, type State } from './buildings.state';

export function buildingsReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.RESET: {
            return { ...initialState };
        }

        case ActionType.FETCH_BUILDINGS: {
            return {
                ...state,
                isPending: true
            };
        }

        case ActionType.FETCH_BUILDINGS_SUCCEEDED: {
            return buildingAdapter.setAll(action.payload.buildings, {
                ...state,
                isPending: false,
                isLoaded: true
            });
        }

        case ActionType.FETCH_BUILDINGS_FAILED: {
            return {
                ...state,
                isPending: false
            };
        }

        case ActionType.CREATE_BUILDING: {
            return buildingAdapter.addOne(action.payload.building, state);
        }

        case ActionType.UPDATE_BUILDING: {
            return buildingAdapter.updateOne({ id: action.payload.buildingId, changes: action.payload.buildingUpdate }, state);
        }

        default:
            return state;
    }
}
